export default "__VITE_ASSET__a7353ab6__"